// #702 — the CNO is `competitorNumber` (the number off the bridle tag,
// unique per show), a distinct field from `rideNumber`. Riders and staff
// call it "the number" and write it as `#999`. Scribe used to bind the
// `rides.ridePrefix` label to `rideNumber` (often empty/wrong in FVD data)
// under a label that said "CNO" — this is the single place every call site
// resolves the number to actually show, falling back to `rideNumber` only
// so nothing renders blank.
export function rideCnoNumber(ride) {
  const cno = ride?.competitorNumber;
  if (cno != null && `${cno}`.trim() !== "") return cno;
  return ride?.rideNumber;
}
